import { Box } from '@mui/material';
import React from 'react';
import * as Redux from 'react-redux';
import GuiaView from './GuiaView';
import IntroView from './IntroView';

const IntroModule = () => {
  const templateStore = Redux.useSelector((state) => state.template);

  return (
    <Box sx={{ maxHeight: '700px' }}>
      {templateStore.settings.intro ? (
        templateStore.settings.guia ? (
          <GuiaView />
        ) : (
          <IntroView />
        )
      ) : null}
    </Box>
  );
};

export default IntroModule;
